const FREE_GIFT_CONFIG = {
  enabled: false,
  debug: true,
  thresholdCents: 3500,
  giftProductIds: [], //11863578083596  11863576772876
  soldOutTags: ['soldout', 'sold-out', 'sold_out', 'sold out', 'ausverkauft'],
  messageTemplate: 'Noch {{amount}} um ein kostenloses Paar Fußball-Socken zu erhalten',
  successMessage: 'Deine kostenlosen Fußballsocken wurden deinem Warenkorb hinzugefügt.',
};

(() => {
  if (window.freeGiftPromotionInitialized) return;
  window.freeGiftPromotionInitialized = true;

  const config = FREE_GIFT_CONFIG;
  const FREE_GIFT_PROPERTY_NAME = '_free_gift_promotion';
  const FREE_GIFT_PROPERTY_VALUE = 'true';
  const giftProductIds = config.giftProductIds.map(Number);
  const giftProductIdSet = new Set(giftProductIds);
  const moneyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  let syncTimer;
  let syncInProgress = false;
  let rerunRequested = false;
  let giftVariantIdPromise;
  const giftVariantIdSet = new Set();

  const getCartUrl = () => window.routes?.cart_url || '/cart';
  const getCartAddUrl = () => window.routes?.cart_add_url || '/cart/add.js';
  const getCartChangeUrl = () => window.routes?.cart_change_url || '/cart/change.js';

  function debugLog(...args) {
    if (config.debug) console.log('[Free gift]', ...args);
  }

  function debugWarn(...args) {
    if (config.debug) console.warn('[Free gift]', ...args);
  }

  function scheduleSync() {
    if (!config.enabled) {
      renderMessage('');
      return;
    }

    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCart, 150);
  }

  function isGiftProductLine(item) {
    return giftProductIdSet.has(Number(item.product_id));
  }

  function isGiftLine(item) {
    return isGiftProductLine(item) && item.properties?.[FREE_GIFT_PROPERTY_NAME] === FREE_GIFT_PROPERTY_VALUE;
  }

  function isBlockedGiftProductLine(item) {
    return isGiftProductLine(item) && !isGiftLine(item);
  }

  function getEligibleSubtotal(cart) {
    return cart.items.reduce((subtotal, item) => {
      return isGiftProductLine(item) ? subtotal : subtotal + item.final_line_price;
    }, 0);
  }

  function getGiftLines(cart) {
    return cart.items.filter(isGiftLine);
  }

  function getBlockedGiftProductLines(cart) {
    return cart.items.filter(isBlockedGiftProductLine);
  }

  function renderMessage(message) {
    document.querySelectorAll('[data-free-gift-message]').forEach((element) => {
      element.textContent = message;
      element.hidden = !message;
    });
  }

  function renderCartState(cart) {
    const eligibleSubtotal = getEligibleSubtotal(cart);

    if (eligibleSubtotal < config.thresholdCents) {
      const remaining = config.thresholdCents - eligibleSubtotal;
      renderMessage(config.messageTemplate.replace('{{amount}}', moneyFormatter.format(remaining / 100)));
    } else {
      renderMessage(getGiftLines(cart).length ? config.successMessage : '');
    }
  }

  async function fetchCart() {
    const response = await fetch(`${getCartUrl()}.js`);
    if (!response.ok) throw new Error('Could not fetch cart');
    return response.json();
  }

  function normalizeTag(tag) {
    return String(tag).toLowerCase().replace(/[\s_-]/g, '');
  }

  function getProductTags(product) {
    if (Array.isArray(product?.tags)) return product.tags;
    if (typeof product?.tags === 'string') return product.tags.split(',').map((tag) => tag.trim());
    return [];
  }

  function hasSoldOutTag(product) {
    const soldOutTags = (config.soldOutTags || []).map(normalizeTag);
    return getProductTags(product).some((tag) => soldOutTags.includes(normalizeTag(tag)));
  }

  async function resolveGiftVariantIds() {
    const productsById = new Map();
    let sinceId = 0;

    while (giftProductIds.some((productId) => !productsById.has(productId))) {
      const response = await fetch(`/products.json?limit=250&since_id=${sinceId}`);
      if (!response.ok) throw new Error('Could not fetch products');

      const { products = [] } = await response.json();
      if (!products.length) break;

      products.forEach((product) => productsById.set(Number(product.id), product));
      sinceId = Number(products[products.length - 1].id);
    }

    return giftProductIds
      .map((productId) => {
        const product = productsById.get(productId);

        if (!product) {
          debugWarn('Gift product could not be found', productId);
          return null;
        }

        if (hasSoldOutTag(product)) {
          debugWarn('Skipping sold-out tagged gift product', productId, getProductTags(product));
          return null;
        }

        const variant = product.variants?.find((item) => item.available);

        if (!variant) {
          debugWarn('Gift product has no available variant to add', productId);
          return null;
        }

        return Number(variant.id);
      })
      .filter(Boolean);
  }

  function getGiftVariantIds() {
    if (!giftVariantIdPromise) giftVariantIdPromise = resolveGiftVariantIds();
    return giftVariantIdPromise;
  }

  function isGiftVariantId(variantId) {
    return giftVariantIdSet.has(Number(variantId));
  }

  function getCartAddForms() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  }

  function getCartAddCards() {
    return Array.from(document.querySelectorAll('[data-card-variant-id][data-card-product-id]'));
  }

  function getFormVariantId(form) {
    return Number(new FormData(form).get('id'));
  }

  function isGiftProductId(productId) {
    return giftProductIdSet.has(Number(productId));
  }

  function getFormSubmitButtons(form) {
    return Array.from(form.querySelectorAll('[type="submit"]'));
  }

  function setBlockedGiftFormState(form, isBlocked) {
    getFormSubmitButtons(form).forEach((button) => {
      if (isBlocked) {
        button.dataset.freeGiftBlocked = 'true';
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        return;
      }

      if (button.dataset.freeGiftBlocked !== 'true') return;

      delete button.dataset.freeGiftBlocked;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    });
  }

  function updateGiftProductForms() {
    getCartAddForms().forEach((form) => {
      setBlockedGiftFormState(form, isGiftVariantId(getFormVariantId(form)));
    });

    getCartAddCards().forEach((card) => {
      setBlockedGiftCardState(card, isBlockedGiftCard(card));
    });
  }

  function blockGiftProductSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    if (!isGiftVariantId(getFormVariantId(form))) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setBlockedGiftFormState(form, true);
    debugWarn('Blocked add to basket submit for gift product');
    scheduleSync();
  }

  function isBlockedGiftCard(card) {
    return isGiftProductId(card.dataset.cardProductId) || isGiftVariantId(card.dataset.cardVariantId);
  }

  function setBlockedGiftCardState(card, isBlocked) {
    if (!isBlocked) return;

    if (card.dataset.available !== 'false') card.dataset.available = 'false';
    if (card.dataset.freeGiftBlocked !== 'true') card.dataset.freeGiftBlocked = 'true';

    card.querySelectorAll('button').forEach((button) => {
      if (!button.hasAttribute('disabled')) button.setAttribute('disabled', 'disabled');
      if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
      if (button.getAttribute('title') !== 'This product is only available as a free gift.') {
        button.setAttribute('title', 'This product is only available as a free gift.');
      }
    });
  }

  function blockGiftProductCardClick(event) {
    const card = event.target.closest?.('[data-card-variant-id][data-card-product-id]');
    if (!card || !isBlockedGiftCard(card)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setBlockedGiftCardState(card, true);
    debugWarn('Blocked card add to basket for gift product');
    scheduleSync();
  }

  const cardAddToBasketObserver = new MutationObserver(updateGiftProductForms);
  cardAddToBasketObserver.observe(document.documentElement, { childList: true, subtree: true });

  getGiftVariantIds()
    .then((variantIds) => {
      variantIds.forEach((variantId) => giftVariantIdSet.add(Number(variantId)));
      updateGiftProductForms();
    })
    .catch((error) => {
      debugWarn('Gift variants could not be resolved for form blocking', error);
    });

  async function addGift() {
    const giftVariantIds = await getGiftVariantIds();

    for (const variantId of giftVariantIds) {
      debugLog('Trying to add gift variant', variantId);

      const response = await fetch(getCartAddUrl(), {
        ...fetchConfig('javascript'),
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            [FREE_GIFT_PROPERTY_NAME]: FREE_GIFT_PROPERTY_VALUE,
          },
          sections: getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      });

      if (response.ok) {
        const state = await response.json();
        debugLog('Gift variant added', variantId, state);
        refreshCartSections(state);
        return true;
      }

      const errorText = await response.clone().text();
      debugWarn('Gift variant could not be added', variantId, response.status, errorText);
    }

    debugWarn('No gift variant could be added');
    return false;
  }

  async function changeGiftLine(line, quantity) {
    const response = await fetch(getCartChangeUrl(), {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: line.key,
        quantity,
        sections: getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) return false;

    const state = await response.json();
    refreshCartSections(state);
    return true;
  }

  async function removeGiftLines(giftLines) {
    for (const giftLine of giftLines) {
      await changeGiftLine(giftLine, 0);
    }
  }

  async function normalizeGiftLines(giftLines) {
    if (!giftLines.length) return false;

    let changed = false;
    const [primaryGift, ...duplicateGifts] = giftLines;

    if (primaryGift.quantity > 1) {
      changed = (await changeGiftLine(primaryGift, 1)) || changed;
    }

    for (const duplicateGift of duplicateGifts) {
      changed = (await changeGiftLine(duplicateGift, 0)) || changed;
    }

    return changed;
  }

  async function syncCart() {
    if (syncInProgress) {
      rerunRequested = true;
      return;
    }

    syncInProgress = true;

    try {
      const cart = await fetchCart();
      const eligibleSubtotal = getEligibleSubtotal(cart);
      const giftLines = getGiftLines(cart);
      const blockedGiftProductLines = getBlockedGiftProductLines(cart);

      debugLog('Cart checked', {
        eligibleSubtotal,
        thresholdCents: config.thresholdCents,
        giftLines,
        blockedGiftProductLines,
        items: cart.items,
      });

      renderCartState(cart);

      if (!config.enabled) return;

      if (blockedGiftProductLines.length) {
        debugWarn('Removing directly added gift product lines', blockedGiftProductLines);
        await removeGiftLines(blockedGiftProductLines);
        rerunRequested = true;
        return;
      }

      if (eligibleSubtotal >= config.thresholdCents) {
        if (giftLines.length) {
          const changed = await normalizeGiftLines(giftLines);
          if (changed) rerunRequested = true;
          return;
        }

        const added = await addGift();
        if (added) rerunRequested = true;
        return;
      }

      if (giftLines.length) {
        await removeGiftLines(giftLines);
        rerunRequested = true;
      }
    } catch (error) {
      console.warn('Free gift promotion could not sync:', error);
    } finally {
      syncInProgress = false;

      if (rerunRequested) {
        rerunRequested = false;
        scheduleSync();
      }
    }
  }

  function getSectionsToRender() {
    const sections = [];

    if (document.getElementById('CartDrawer')) {
      sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    }

    if (document.getElementById('cart-icon-bubble')) {
      sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      sections.push({ id: 'main-cart-items', section: mainCartItems.dataset.id, selector: '.js-contents' });
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter) {
      sections.push({ id: 'main-cart-footer', section: mainCartFooter.dataset.id, selector: '.js-contents' });
    }

    return sections.filter((section) => section.section);
  }

  function refreshCartSections(state) {
    if (!state?.sections) return;

    getSectionsToRender().forEach((section) => {
      const sectionHtml = state.sections[section.section];
      const target = document.getElementById(section.id);
      if (!sectionHtml || !target) return;

      const source = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector(section.selector);
      const elementToReplace = target.querySelector(section.selector) || target;

      if (source && elementToReplace) {
        elementToReplace.innerHTML = source.innerHTML;
      }
    });

    if (typeof state.item_count === 'number') {
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', state.item_count === 0);
      document.querySelector('cart-items')?.classList.toggle('is-empty', state.item_count === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', state.item_count === 0);
    }

    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cartData: state });
    }
  }

  function parseCartAddBody(init) {
    const body = init?.body;
    if (!body) return null;

    if (body instanceof FormData || body instanceof URLSearchParams) {
      return {
        id: body.get('id'),
        properties: {
          [FREE_GIFT_PROPERTY_NAME]: body.get(`properties[${FREE_GIFT_PROPERTY_NAME}]`),
        },
      };
    }

    if (typeof body !== 'string') return null;

    try {
      return JSON.parse(body);
    } catch (error) {
      return Object.fromEntries(new URLSearchParams(body));
    }
  }

  async function isBlockedGiftAdd(url, init) {
    if (!url?.includes('/cart/add') || syncInProgress) return false;

    const body = parseCartAddBody(init);
    const variantId = Number(body?.id || body?.items?.[0]?.id);
    const isPromotionAdd =
      body?.properties?.[FREE_GIFT_PROPERTY_NAME] === FREE_GIFT_PROPERTY_VALUE ||
      body?.items?.[0]?.properties?.[FREE_GIFT_PROPERTY_NAME] === FREE_GIFT_PROPERTY_VALUE;

    if (!variantId || isPromotionAdd) return false;

    return (await getGiftVariantIds()).includes(variantId);
  }

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'free-gift') return;
      scheduleSync();
    });
  }

  const originalFetch = window.fetch;
  window.fetch = async function(resource, init) {
    const url = typeof resource === 'string' ? resource : resource?.url;
    if (await isBlockedGiftAdd(url, init)) {
      debugWarn('Blocked direct add for gift product');
      scheduleSync();

      return new Response(
        JSON.stringify({
          status: 422,
          message: 'This product is only available as a free gift.',
          description: 'This product is only available as a free gift.',
        }),
        {
          status: 422,
          headers: { 'Content-Type': 'application/json' },
        }
      );
    }

    const response = await originalFetch.apply(this, arguments);
    const isCartMutation =
      url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'));

    if (isCartMutation && !syncInProgress) scheduleSync();

    return response;
  };

  document.addEventListener('DOMContentLoaded', scheduleSync);
  document.addEventListener('DOMContentLoaded', updateGiftProductForms);
  document.addEventListener('submit', blockGiftProductSubmit, true);
  document.addEventListener('click', blockGiftProductCardClick, true);
  document.addEventListener('change', updateGiftProductForms, true);
  window.addEventListener('pageshow', scheduleSync);
  window.addEventListener('pageshow', updateGiftProductForms);
})();
